const BACKEND = process.env.REACT_APP_BACKEND_URL;

function ident() {
  let pid = localStorage.getItem("cq_city_pid");
  if (!pid) { pid = `p${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`; localStorage.setItem("cq_city_pid", pid); }
  let name = localStorage.getItem("cq_city_name");
  if (!name) { name = `Duck-${Math.floor(1000 + Math.random() * 9000)}`; localStorage.setItem("cq_city_name", name); }
  const hat = Number(localStorage.getItem("cq_city_hat") || Math.floor(Math.random() * 6));
  return { pid, name, hat };
}

export function createNet({ onSnap, onWave, onStatus, onText, onVisit, onWall, onTyping, onReact, onWallErr }) {
  const me = ident();
  let ws = null, alive = true, timer = null, last = "", lastMeta = "", role = "visitor", backoff = 800;
  const url = BACKEND.replace(/^http/, "ws") + "/api/city/ws";

  const send = (o) => { if (ws && ws.readyState === 1) ws.send(JSON.stringify(o)); };
  const connect = () => {
    if (!alive) return;
    try { ws = new WebSocket(url); } catch { return; }
    ws.onopen = () => { backoff = 800; send({ t: "join", pid: me.pid, name: me.name, role, hat: me.hat }); onStatus?.("online"); };
    ws.onmessage = (e) => {
      let m; try { m = JSON.parse(e.data); } catch { return; }
      if (m.t === "snap") onSnap?.(m.players.filter((p) => p.pid !== me.pid), m.n);
      else if (m.t === "wave") onWave?.(m.from);
      else if (m.t === "text") onText?.(m);
      else if (m.t === "visit") onVisit?.(m);
      else if (m.t === "welcome") onStatus?.("online", m.n);
      else if (m.t === "wall") onWall?.(m.note);
      else if (m.t === "typing") onTyping?.(m);
      else if (m.t === "react") onReact?.(m);
      else if (m.t === "wallerr") onWallErr?.(m.error);
    };
    ws.onclose = () => { onStatus?.("offline"); if (alive) { timer = setTimeout(connect, backoff); backoff = Math.min(8000, backoff * 1.6); } };
    ws.onerror = () => { try { ws.close(); } catch {} };
  };

  return {
    me,
    start(r) { role = r || "visitor"; connect(); },
    stop() { alive = false; clearTimeout(timer); try { ws?.close(); } catch {} },
    pos(x, scene, facing, moving, car, alt = 0) {
      const key = `${Math.round(x)}|${scene}|${facing}|${moving ? 1 : 0}|${car || ""}|${alt}`;
      if (key === last) return;
      last = key;
      send({ t: "pos", x: Math.round(x), scene, facing, moving, car: car || null, alt });
    },
    say(text) { send({ t: "say", text }); },
    text(to, text) { send({ t: "text", to, text }); },
    visit(to, kind, payload) { send({ t: "visit", to, kind, payload: payload || {} }); },
    meta(outfit) { const k = JSON.stringify(outfit || {}); if (k === lastMeta) return; lastMeta = k; send({ t: "outfit", outfit: outfit || {} }); },
    wave(to) { send({ t: "wave", to }); },
    wall(text) { send({ t: "wall", text }); },
    typing() { send({ t: "typing" }); },
    react(id, emoji) { send({ t: "react", id, emoji }); },
    rename(name, hat) {
      me.name = name.trim().slice(0, 16) || me.name; me.hat = hat ?? me.hat;
      localStorage.setItem("cq_city_name", me.name); localStorage.setItem("cq_city_hat", String(me.hat));
      send({ t: "name", name: me.name, hat: me.hat });
    },
  };
}
